import * as Constants from '../utilities/constants/Constants';
import {
  isStartUpScene,
  isBlockchainTransactionEnabled,
  getCostCurrency
} from '../utilities/HelperFunctions/HelperFunctions';
import { isLaptopsApp } from '../utilities/HelperFunctions/SignageHelperFunctions';
import * as api from '../services/api';
import {
  setMessageDialogParams,
  setLoadingState,
  checkForBlockChainTransaction,
  setBlockchainTransactionInProgress
} from './fabricCanvasActions';
import { string } from '../localization';
import { getPlacings } from './ProjectData/Project';

let scenePublishRequestPoller;
let requestPoller;

export const startPollingForPublish = () => (dispatch, getState) => {
  if (dispatch(checkForBlockChainTransaction())) {
    const { project } = getState().finalCheck;
    const allPlacings = getPlacings(project);
    const filteredPlacings = dispatch(getFilteredPlacings(allPlacings));

    for (let i = 0; i < filteredPlacings.length; i++) {
      const placing = filteredPlacings[i];
      if (isRequestValidForScene(placing)) {
        if (!dispatch(isStartUpScene(placing))) {
          dispatch(checkForScenePublish(placing));
        }
      } else if (isRequestValidForObject(placing)) {
        dispatch(checkForElementPublish(placing));
      }
    }
  }
};

const getFilteredPlacings = placings => () => {
  const filteredPlacings = [];
  for (let i = 0; i < placings.length; i++) {
    const id = placings[i].placeableId;

    const alreadyExist =
      filteredPlacings.filter(placing => placing.placeableId == id).length > 0;
    if (!alreadyExist) {
      filteredPlacings.push(placings[i]);
    }
  }
  return filteredPlacings;
};

const isRequestValidForScene = placing =>
  placing.userPhotoType == Constants.USER_PHOTO_SCENE_TYPE ||
  placing.placeableType == Constants.SCENE_KEY;

const isRequestValidForObject = placing =>
  placing.userPhotoType == Constants.USER_PHOTO_ELEMENT_TYPE ||
  placing.placeableType == Constants.ELEMENT_KEY;

const checkForScenePublish = placing => (dispatch, getState) => {
  if (
    dispatch(isBlockchainTransactionEnabled()) &&
    isLaptopsApp(getState().home.selectedProduct.groupType)
  ) {
    if (scenePublishRequestPoller) {
      stopScenePublishRequestPoller();
    }
    dispatch(startScenePublishRequestPoller(placing));
  }
};

const checkForElementPublish = placing => (dispatch, getState) => {
  if (
    dispatch(isBlockchainTransactionEnabled()) &&
    isLaptopsApp(getState().home.selectedProduct.groupType)
  ) {
    dispatch(startElementPublishRequestPoller(placing));
  }
};

const startScenePublishRequestPoller = placing => dispatch => {
  scenePublishRequestPoller = setInterval(() => {
    dispatch(pollForPublishRequest(placing, scenePublishRequestPoller));
  }, 2000);
};

const startElementPublishRequestPoller = placing => dispatch => {
  const elementPublishRequestPoller = setInterval(() => {
    dispatch(pollForPublishRequest(placing, elementPublishRequestPoller));
  }, 2000);
};

const stopScenePublishRequestPoller = () => {
  clearInterval(scenePublishRequestPoller);
};

const pollForPublishRequest = (placing, timer) => (dispatch, getState) => {
  const contentType = placing.placeableType;
  const contentId = placing.placeableId;
  const storeId = getState().modal.storeData.id;
  const { msrpCurrency } = getState().modal.storeData;
  api
    .pollForPublishRequest(contentType, contentId)
    .then(res => {
      if (res.status === 200) {
        const dataJson = res.data;
        if (dataJson.result == 'PROCESSING') {
          return;
        }
        if (
          dataJson.result == 'UNKNOWN' ||
          dataJson.result == 'ERROR' ||
          dataJson.result == 'INVALID'
        ) {
          sendPublishRequest(placing, storeId, msrpCurrency);
        }
        if (dataJson.result == 'PENDING') {
          clearInterval(timer);
          const dict = {
            header: dataJson.data.invalid_transactions,
            description: '',
            stringColor: Constants.ERROR_STRING_COLOR,
            onclick: null,
            buttonTitles: { finish: string.OK_KEY, cancel: '' }
          };

          dispatch(setMessageDialogParams(dict));
        } else if (dataJson.result == 'SUCCESS') {
          clearInterval(timer);
        }
      } else {
        sendPublishRequest(placing, storeId, msrpCurrency);
      }
    })
    .catch(() => {
      sendPublishRequest(placing, storeId, msrpCurrency);
    });
};

const sendPublishRequest = (placing, storeId, msrpCurrency) => {
  const contentType = placing.placeableType;
  const contentId = placing.placeableId;
  let contentSource = 'HP Personalization Platform';
  let contentCost = 0.0;
  let contentCurrency = msrpCurrency;
  let allowedCopies = -1;
  if (
    contentType == Constants.USER_PHOTO_TYPE &&
    placing.imageSource != Constants.LOCAL_IMAGE_SOURCE
  ) {
    contentSource = placing.imageSource;
    if (placing.placeable.costValue != null) {
      contentCost = placing.placeable.costValue;
    }

    const costCurrency = getCostCurrency(placing.placeable);
    if (costCurrency != null) {
      contentCurrency = costCurrency;
    }
    allowedCopies = 1;
  }
  if (contentCurrency == '€') {
    contentCurrency = 'EUR';
  }
  const publishDetails = {
    content_id: contentId,
    content_type: contentType,
    content_source: contentSource,
    content_cost: contentCost,
    cost_currency: contentCurrency,
    allowed_number_of_copies: allowedCopies
  };

  const requestData = {
    transaction: publishDetails
  };
  const requestDataJSON = JSON.stringify(requestData);
  const postData = `request=${escape(requestDataJSON)}`;
  api
    .publishRequestForBlockChain(storeId, postData)
    .then(() => {})
    .catch(() => {});
};

export const initiateCreateRequest = continueWithCall => dispatch => {
  if (dispatch(checkForBlockChainTransaction())) {
    dispatch(setBlockchainTransactionInProgress(true));
    dispatch(
      setLoadingState(`${string.PLEASE_WAIT} ${string.PROTECTING_YOUR_DATA}`)
    );
    dispatch(
      checkForCreate((result, inMessage) => {
        let message = inMessage;
        if (result) {
          continueWithCall();
        } else {
          dispatch(setLoadingState(null));
          dispatch(setBlockchainTransactionInProgress(false));
          message = message.replace(/[0-9:,]/g, '');
          const dict = {
            header: message,
            description: '',
            stringColor: Constants.ERROR_STRING_COLOR,
            onclick: null,
            buttonTitles: { finish: string.OK_KEY, cancel: '' }
          };

          dispatch(setMessageDialogParams(dict));
        }
      })
    );
  } else {
    continueWithCall();
  }
};

const checkForCreate = aCallback => (dispatch, getState) => {
  if (
    dispatch(isBlockchainTransactionEnabled()) &&
    isLaptopsApp(getState().home.selectedProduct.groupType) &&
    dispatch(isCreateRequestValid())
  ) {
    dispatch(startRequestPoller(aCallback));
  } else {
    aCallback(true, '');
  }
};

const isCreateRequestValid = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const allPlacings = getPlacings(project);
  let isValid = false;
  allPlacings.forEach(placing => {
    isValid = isValid || dispatch(validtyForPublishAndCreate(placing));
  });
  return isValid;
};

const validtyForPublishAndCreate = placing => dispatch => {
  if (
    placing.userPhotoType == Constants.USER_PHOTO_SCENE_TYPE ||
    (placing.placeableType == Constants.SCENE_KEY &&
      !dispatch(isStartUpScene(placing))) ||
    isRequestValidForObject(placing)
  ) {
    return true;
  }
  return false;
};

const startRequestPoller = callback => dispatch => {
  requestPoller = setInterval(() => {
    dispatch(pollForCreateRequest(callback));
  }, 5000);
};

const pollForCreateRequest = callback => (dispatch, getState) => {
  const { category } = getState().modal.envData;
  const { id, projectGroupId } = getState().finalCheck.project;
  api
    .pollForCreateRequest(projectGroupId)
    .then(response => {
      if (response.status === 200) {
        const dataJson = response.data;
        if (dataJson.result == 'PROCESSING') {
          return;
        }
        if (dataJson.result == 'ERROR') {
          dispatch(sendCreateRequest(id, projectGroupId, category));
        }
        if (
          dataJson.result == 'PENDING' ||
          dataJson.result == 'UNKNOWN' ||
          dataJson.result == 'INVALID'
        ) {
          clearInterval(requestPoller);
          callback(false, dataJson.data.invalid_transactions);
        } else if (dataJson.result == 'SUCCESS') {
          clearInterval(requestPoller);
          callback(true, '');
        }
      } else {
        dispatch(sendCreateRequest(id, projectGroupId, category));
      }
    })
    .catch(() => {
      dispatch(sendCreateRequest(id, projectGroupId, category));
    });
};

const sendCreateRequest = (projectId, groupId, category) => (
  dispatch,
  getState
) => {
  const contentDetails = dispatch(getContentDetails());
  const storeId = getState().modal.storeData.id;
  const createDetails = {
    project_id: projectId,
    project_group_id: groupId,
    project_category: category,
    content_details: contentDetails
  };
  blockChainCreateRequest(createDetails, storeId);
};

const getContentDetails = () => (dispatch, getState) => {
  const contentDetailsArray = [];
  const { project } = getState().finalCheck;
  const allPlacings = getPlacings(project);
  const filteredPlacings = dispatch(getFilteredPlacings(allPlacings));

  for (let i = 0; i < filteredPlacings.length; i++) {
    const placing = filteredPlacings[i];
    if (dispatch(validtyForPublishAndCreate(placing))) {
      const dict = {
        content_id: placing.placeableId,
        content_type: placing.placeableType
      };
      contentDetailsArray.push(dict);
    }
  }
  return contentDetailsArray;
};

const blockChainCreateRequest = (inDetails, storeId) => {
  const anArray = inDetails.content_details;
  const contentArray = [];
  for (let i = 0; i < anArray.length; i++) {
    const contentDetails = {
      content_id: anArray[i].content_id,
      content_type: anArray[i].content_type
    };
    contentArray[i] = contentDetails;
  }

  const createDetails = {
    project_id: inDetails.project_id,
    project_group_id: inDetails.project_group_id,
    project_category: inDetails.project_category,
    content_details: contentArray
  };
  const requestData = {
    transaction: createDetails
  };
  const requestDataJSON = JSON.stringify(requestData);
  const postData = `request=${escape(requestDataJSON)}`;
  api
    .blockChainCreateRequest(storeId, postData)
    .then(() => {})
    .catch(() => {});
};
